import { useMemo } from 'react';

import { type FWaypointTemplateFragment, useWaypointTemplateQuery } from '@dashboard/generated/wp/platform';
import { buildDocumentConfiguration, type TTemplate } from '@wp-block-builder/package';

type TResult =
  | { loading: true; data: undefined }
  | { loading: false; data: TTemplate & { strictVariablesRendering: boolean } };

export default function useTemplateConfiguration(template: FWaypointTemplateFragment): TResult {
  const layoutId = template.activeConfiguration.layoutId;
  const { data, loading } = useWaypointTemplateQuery({
    variables: { id: layoutId ?? '' },
    skip: typeof layoutId !== 'string',
  });

  const layoutTemplate = data?.WaypointTemplate;

  return useMemo(() => {
    if (loading) {
      return { loading: true, data: undefined };
    }

    let layoutConfiguration = null;
    if (layoutTemplate) {
      layoutConfiguration = layoutTemplate.activeConfiguration;
    }
    return {
      loading: false,
      data: buildDocumentConfiguration(template.activeConfiguration, layoutConfiguration),
    };
  }, [layoutTemplate, template, loading]);
}
